
import { tx, lz } from "@/i18n";export const LOGO_FULL = "/brand/logo-full.png";
export const LOGO_ROUND = "/brand/logo-round.png";
export const FAVICON = "/brand/favicon.png";

export const ROLE_LABELS = lz({
  admin: "Administrator",
  client: "Eigenaar",
  guest: "Gast",
  host: "Host",
  cleaner: "Schoonmaak",
  subcontractor: "Onderhoud",
});

// Medewerker-subtypes (koepel "Medewerker")
export const STAFF_SUBROLES = ["host", "cleaner", "subcontractor"];
export const MEDEWERKER_SUBTYPES = lz([
  { value: "host", label: "Host" },
  { value: "cleaner", label: "Schoonmaak" },
  { value: "subcontractor", label: "Onderhoud" },
]);
export const isStaff = (role) => STAFF_SUBROLES.includes(role);

const HOUSE_COVER_FALLBACK = "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
export const houseCoverUrl = (house, fallback = HOUSE_COVER_FALLBACK, w = 1600) => {
  const id = house?.id || house?.house_id;
  if (id && (house?.cover_photo_path || house?.has_cover)) {
    const v = house?.cover_updated_at ? `&v=${encodeURIComponent(house.cover_updated_at)}` : "";
    return `${process.env.REACT_APP_BACKEND_URL}/api/houses/${id}/cover?w=${w}${v}`;
  }
  return house?.image_url || fallback;
};

export const mapsUrl = (address) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

export const BOOKING_TYPES = lz({
  checkin: { label: "Check-in", color: "bg-secondary/15 text-secondary" },
  checkout: { label: "Check-out", color: "bg-amber-100 text-amber-700" },
  cleaning: { label: "Schoonmaak", color: "bg-blue-100 text-blue-700" },
  maintenance: { label: "Onderhoud", color: "bg-purple-100 text-purple-700" },
  inspection: { label: "Inspectie", color: "bg-primary/15 text-primary" },
});
